/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { applyMiddleware, compose, createStore } from 'redux'
import promiseMiddleware from 'redux-promise-middleware'
import thunk from 'redux-thunk'
import { permanentMiddleware, loadState } from './middlewares/permanent'
import { fetchMiddleware } from './middlewares/fetch'
import { makeRootReducer } from './modules/index'

declare const window: any

const create = (initialState: any = loadState(), middlewares = []) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [
    permanentMiddleware,
    thunk,
    fetchMiddleware,
    promiseMiddleware(),
    ...middlewares,
  ]

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = []
  let composeEnhancers = compose

  if (__DEV__) {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store: any = createStore(
    makeRootReducer({}),
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware),
      ...enhancers,
    ),
  )
  store.asyncReducers = {}

  store.injectReducer = reducersMap => {
    store.asyncReducers = {
      ...store.asyncReducers,
      ...reducersMap,
    }
    store.replaceReducer(makeRootReducer(store.asyncReducers))
  }

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime
  // store.unsubscribeHistory = browserHistory.listen(location(store))

  if (module.hot) {
    module.hot.accept('./modules', () => {
      const reducers = require('./modules/index')
      store.replaceReducer(reducers.makeRootReducer(store.asyncReducers))
    })
  }

  return store
}

export default create
